import React, { useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import PharmacyReceiptReport, { PharmacyReceipt } from './PharmacyReceiptReport';
import { generatePDF } from '../../../utils/reportUtils';
import ReportDialog from '../ReportDialog';

type Props = {
  open: boolean;
  onClose: () => void;
  data: PharmacyReceipt | null;
  isLoading?: boolean;
  error?: string | null;
};

const PharmacyReceiptReportGen: React.FC<Props> = ({
  open,
  onClose,
  data,
  isLoading = false,
  error = null,
}) => {
  const reportRef = useRef<HTMLDivElement>(null);

  const handleDownloadPDF = () => {
    if (reportRef.current && data) {
      generatePDF(reportRef.current, `Pharmacy_Receipt_${data.receipt_no}`);
    }
  };

  const handlePrint = () => window.print();

  return (
    <ReportDialog
      open={open}
      onClose={onClose}
      title="Pharmacy Payment Receipt"
      onDownload={data ? handleDownloadPDF : undefined}
      onPrint={data ? handlePrint : undefined}
      downloadLabel="Download Receipt"
      printLabel="Print Receipt"
    >
      {isLoading ? (
        <Box sx={{ py: 8, textAlign: 'center' }}>
          <CircularProgress size={40} />
          <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
            Loading pharmacy receipt...
          </Typography>
        </Box>
      ) : error ? (
        <Box sx={{ py: 8, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'error.main' }}>
            {error}
          </Typography>
        </Box>
      ) : data ? (
        <div ref={reportRef}>
          <PharmacyReceiptReport receiptData={data} />
        </div>
      ) : (
        <Box sx={{ py: 8, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            No pharmacy receipt data available.
          </Typography>
        </Box>
      )}
    </ReportDialog>
  );
};

export default PharmacyReceiptReportGen;
